import { toPath } from '../routes'

export const commentableTypes = {
  Patient: { route: 'patients.patient', params: ['id'], apiRoute: 'patients' },
  Alert: { route: 'alerts.alert', params: ['id'], apiRoute: 'alerts' },
  OfficeCheck: {
    route: 'practices.officeChecks.officeCheck',
    params: ['practiceId', 'id'],
    apiRoute: 'office-checks',
  },
  Report: { route: 'reports.report', params: ['id'], apiRoute: 'reports' },
  PreAuthorization: {
    route: 'preAuthorizations.preAuthorization',
    params: ['id'],
    apiRoute: 'pre-authorizations',
  },
}

function getNestedRoute(to, route) {
  return route.split('.').reduce((acc, key) => acc[key], to)
}

export function getCommentablePath(type, record, practiceId = null) {
  const { route, params } = commentableTypes[type]

  const providedParams = params.reduce((acc, param) => {
    if (param === 'practiceId' && practiceId) {
      acc[param] = practiceId
    } else {
      acc[param] = record.commentableId
    }
    return acc
  }, {})

  const pathFunction = getNestedRoute(toPath, route)

  return pathFunction(providedParams)
}

export function getApiRoute(type, practiceId = null) {
  if (type === 'OfficeCheck') {
    return `practices/${practiceId}/office-checks`
  }
  return commentableTypes[type].apiRoute
}
